var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Separator, TextField } from "@atlassiansox/microscopekit";
import createServiceNotification from "../../graphql/service-notification-create.mutation.graphql";
import { Checkbox } from "@atlaskit/checkbox";
import { useMutationUI } from "../../hooks";
import { LoadingButton } from "@atlaskit/button";
var NotificationCreateFormComponent = function (_a) {
    var serviceId = _a.serviceId, setServiceNotification = _a.setServiceNotification;
    var _b = __read(useState(""), 2), slackChannel = _b[0], setSlackChannel = _b[1];
    var _c = __read(useState([]), 2), subscriptions = _c[0], setSubscriptions = _c[1];
    function handleSubscriptionChange(event) {
        var subscription = event.target.value;
        var tmpSubscriptions = [];
        if (subscriptions.includes(subscription)) {
            subscriptions.forEach(function (value) {
                if (value !== subscription) {
                    tmpSubscriptions.push(value);
                }
            });
        }
        else {
            subscriptions.forEach(function (value) {
                tmpSubscriptions.push(value);
            });
            tmpSubscriptions.push(subscription);
        }
        setSubscriptions(tmpSubscriptions);
    }
    var _d = useMutationUI({
        mutation: createServiceNotification,
        successMessage: "Notifications enabled successfully",
        options: {
            variables: {
                input: {
                    channel: slackChannel,
                    service: serviceId,
                    subscriptions: subscriptions
                }
            },
            onCompleted: function (_a) {
                var configureNotification = _a.configureNotification;
                return setServiceNotification(configureNotification);
            }
        }
    }), mutate = _d.mutate, isLoading = _d.isLoading;
    return (React.createElement("div", null,
        React.createElement(Separator, null),
        React.createElement("h4", null, "Configure Notification"),
        React.createElement(Separator, null),
        React.createElement("label", null,
            "Channel",
            React.createElement(TextField, { name: "Channel", value: slackChannel, onChange: function (e) {
                    setSlackChannel(e.target.value);
                }, placeholder: "Slack Channel" })),
        React.createElement("h4", null, "Subscriptions"),
        React.createElement(Checkbox, { name: "subscription_wargame", value: "wargame", isChecked: subscriptions.includes("wargame"), onChange: handleSubscriptionChange, label: "Wargame" }),
        React.createElement(Checkbox, { name: "subscription_schedule", value: "schedule", isChecked: subscriptions.includes("schedule"), onChange: handleSubscriptionChange, label: "Schedule" }),
        React.createElement(LoadingButton, { onClick: function () { return mutate(); }, appearance: "primary", isDisabled: slackChannel.length === 0 || subscriptions.length === 0, isLoading: isLoading }, "Submit")));
};
export var NotificationCreateForm = NotificationCreateFormComponent;
